import type { Scene, Camera } from "three";
import { CHAPTER_COUNT, chapterFromProgress } from "../scroll/progress";

export interface ChapterCtx {
  scene: Scene;
  camera: Camera;
}

export interface Chapter {
  id: number;
  enter(ctx: ChapterCtx): void;
  exit(ctx: ChapterCtx): void;
  update(ctx: ChapterCtx, t: number, dt: number, localProgress: number): void;
}

export class ChapterManager {
  private active = -1;
  constructor(private chapters: Chapter[], private ctx: ChapterCtx) {}

  setProgress(p: number, t: number, dt: number) {
    const next = chapterFromProgress(p);
    if (next !== this.active) {
      if (this.active >= 0) this.chapters[this.active].exit(this.ctx);
      this.chapters[next].enter(this.ctx);
      this.active = next;
    }
    const span = 1 / CHAPTER_COUNT;
    const local = Math.max(0, Math.min(1, (p - next * span) / span));
    this.chapters[next].update(this.ctx, t, dt, local);
  }
}
